import { render, staticRenderFns } from "./206.vue?vue&type=template&id=36b64dad&scoped=true&"
var script = {}
import style0 from "./206.vue?vue&type=style&index=0&id=36b64dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b64dad",
  null
  
)

export default component.exports